var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandAllIcon = function SvgExpandAllIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    fillRule: "evenodd",
    d: "M9.602 1.165c.22-.22.576-.22.796 0l2.1 2.1a.563.563 0 0 1-.398.96h-1.35v2.063a.75.75 0 0 1-1.5 0V4.224H7.9a.563.563 0 0 1-.398-.96zm1.148 12.548a.75.75 0 0 0-1.5 0V15.7H7.9a.562.562 0 0 0-.405.953l2.1 2.175a.563.563 0 0 0 .81 0l2.1-2.175a.563.563 0 0 0-.405-.953h-1.35zm-9.75-6c0-1.24 1.01-2.25 2.25-2.25H7a.75.75 0 0 1 0 1.5H3.25c-.41 0-.75.339-.75.75v4.574c0 .411.34.75.75.75H7a.75.75 0 0 1 0 1.5H3.25c-1.24 0-2.25-1.01-2.25-2.25V7.712zm12-2.25a.75.75 0 0 0 0 1.5h3.75c.41 0 .75.339.75.75v4.574c0 .411-.34.75-.75.75H13a.75.75 0 0 0 0 1.5h3.75c1.24 0 2.25-1.01 2.25-2.25V7.712c0-1.239-1.01-2.25-2.25-2.25H13z",
    clipRule: "evenodd"
  })));
};
export { SvgExpandAllIcon as ReactComponent };